/**
 * Zeigt ein Zertifikat eine Stundenangabe? Kurszertifikate können ohne Stunden ausgestellt werden
 * (courses.certificate_hours = NULL, z. B. die vier Kurse von Musik und Sprache). Dann darf weder
 * „0 Stunden" noch „null" erscheinen. Achtung bei JSX: `{cert.hours && …}` zeigt bei 0 eine „0".
 */
export function hatStundenangabe(hours: number | null | undefined): hours is number {
  return typeof hours === "number" && Number.isFinite(hours) && hours > 0;
}
